module.exports = __webpack_public_path__ + "img/home.dc940cab.svg";